var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignCenterHorizontal = function SvgIconAlignCenterHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a1 1 0 0 1 1 1v.875h4.25c.966 0 1.75.784 1.75 1.75v3.75a1.75 1.75 0 0 1-1.75 1.75H13v1.75h6.5c.966 0 1.75.784 1.75 1.75v3.75a1.75 1.75 0 0 1-1.75 1.75H13V21a1 1 0 1 1-2 0v-.875H4.5a1.75 1.75 0 0 1-1.75-1.75v-3.75c0-.966.784-1.75 1.75-1.75H11v-1.75H6.75A1.75 1.75 0 0 1 5 9.375v-3.75c0-.966.784-1.75 1.75-1.75H11V3a1 1 0 0 1 1-1m7.25 16.125v-3.25H4.75v3.25zm-2.25-9H7v-3.25h10z",
    clipRule: "evenodd"
  })));
};
export default SvgIconAlignCenterHorizontal;